(function () {
  'use strict';

  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var scrollTicking = false;
  var tiltRevealObserver = null;
  var cartRevealObserver = null;
  var restPositions = ['left', 'soft-right', 'soft-left', 'right'];

  function queryWithin(root, selector) {
    var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    return elements;
  }

  function setupTiltCard(card, index) {
    if (card.dataset.iosTiltReady === 'true') return;

    card.dataset.iosTiltReady = 'true';
    card.dataset.iosTilt = '';
    card.dataset.iosRest = restPositions[index % restPositions.length];
    card.removeAttribute('data-ios-tilt-pending');

    card.addEventListener('pointermove', function (event) {
      var rect = card.getBoundingClientRect();
      var nx = (event.clientX - rect.left) / rect.width - 0.5;
      var ny = (event.clientY - rect.top) / rect.height - 0.5;

      card.style.setProperty('--jomo-tilt-x', (ny * -2.2).toFixed(2) + 'deg');
      card.style.setProperty('--jomo-tilt-y', (nx * 2.7).toFixed(2) + 'deg');
      card.style.setProperty('--jomo-lift', '-3px');
    });

    card.addEventListener('pointerleave', function () {
      card.style.setProperty('--jomo-tilt-x', '0deg');
      card.style.setProperty('--jomo-tilt-y', '0deg');
      card.style.setProperty('--jomo-lift', '0px');
    });
  }

  function ensureTiltRevealObserver() {
    if (tiltRevealObserver || !document.documentElement) return;

    tiltRevealObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var card = mutation.target;
        if (
          card instanceof HTMLElement &&
          card.dataset.iosTiltPending === 'true' &&
          card.classList.contains('visible')
        ) {
          setupTiltCard(card, Number(card.dataset.iosTiltIndex || 0));
        }
      });
    });

    tiltRevealObserver.observe(document.documentElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class'],
    });
  }

  function initTilt(root) {
    if (!finePointer.matches || reducedMotion.matches) return;

    var cards = queryWithin(
      root,
      [
        '.aura-bento__card:not(.aura-bento__card--art)',
        '.aura-stat',
        '.aura-color',
        '.aura-review',
        '.aura-show__card',
        '.hiw-step',
        '.lk-feature-card',
        '.lk-which__card',
        '.lk-bundle',
        '.lk-painpoint-card',
        '.lk-step',
        '.lk-guarantee__card',
        '.product-card',
      ].join(', ')
    );

    ensureTiltRevealObserver();

    cards.forEach(function (card, index) {
      if (card.dataset.iosTiltReady === 'true') return;

      if (card.matches('.reveal, .reveal-scale') && !card.classList.contains('visible')) {
        card.dataset.iosTiltPending = 'true';
        card.dataset.iosTiltIndex = String(index);
        return;
      }

      setupTiltCard(card, index);
    });
  }

  function initLiquidHeader(root) {
    if (!finePointer.matches || reducedMotion.matches) return;

    queryWithin(root, '#lockin-header .lh__inner').forEach(function (surface) {
      if (surface.dataset.jomoGlassReady === 'true') return;
      surface.dataset.jomoGlassReady = 'true';

      var frame = 0;
      var nextX = 78;
      var nextY = 0;

      surface.addEventListener('pointermove', function (event) {
        var rect = surface.getBoundingClientRect();
        nextX = Math.max(4, Math.min(96, ((event.clientX - rect.left) / rect.width) * 100));
        nextY = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));

        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          surface.style.setProperty('--jomo-glass-x', nextX.toFixed(1) + '%');
          surface.style.setProperty('--jomo-glass-y', nextY.toFixed(1) + '%');
          frame = 0;
        });
      });

      surface.addEventListener('pointerleave', function () {
        surface.style.setProperty('--jomo-glass-x', '78%');
        surface.style.setProperty('--jomo-glass-y', '0%');
      });
    });
  }

  function initHero(root) {
    if (!finePointer.matches || reducedMotion.matches) return;

    queryWithin(root, '.aura-hero').forEach(function (hero) {
      if (hero.dataset.iosHeroReady === 'true') return;
      hero.dataset.iosHeroReady = 'true';

      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        hero.style.setProperty('--jomo-hero-x', (x * -4).toFixed(1) + 'px');
        hero.style.setProperty('--jomo-hero-y', (y * -3).toFixed(1) + 'px');
      });

      hero.addEventListener('pointerleave', function () {
        hero.style.setProperty('--jomo-hero-x', '0px');
        hero.style.setProperty('--jomo-hero-y', '0px');
      });
    });
  }

  function initScrollItems(root) {
    var configs = [
      { selector: '.aura-hero__bg', strength: 14, rotate: 0 },
      { selector: '.aura-bento__art', strength: 9, rotate: 0.72 },
      { selector: '.lk-gallery__main', strength: 6, rotate: 0 },
      { selector: '.cart-page__mascot', strength: 10, rotate: 0 },
    ];

    configs.forEach(function (config) {
      queryWithin(root, config.selector).forEach(function (item) {
        item.dataset.jomoScroll = '';
        item.dataset.jomoScrollStrength = String(config.strength);
        item.dataset.jomoScrollRotate = String(config.rotate);
      });
    });
  }

  function updateScrollMotion() {
    scrollTicking = false;
    if (reducedMotion.matches) return;

    var viewport = window.innerHeight || 1;
    var mobileFactor = window.innerWidth < 720 ? 0.62 : 1;

    document.querySelectorAll('[data-jomo-scroll]').forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - viewport / 2) / viewport));
      var strength = Number(item.dataset.jomoScrollStrength || 8) * mobileFactor;
      var rotate = Number(item.dataset.jomoScrollRotate || 0) * mobileFactor;

      item.style.setProperty('--jomo-scroll-y', (-progress * strength).toFixed(2) + 'px');
      item.style.setProperty('--jomo-scroll-rotate', (-progress * rotate).toFixed(3));
    });
  }

  function initCartReveal(root) {
    var elements = queryWithin(
      root,
      '.cart-page__title, .cart-page__items, .cart-page__summary, .cart-page__more-blocks'
    );

    if (!elements.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach(function (element) { element.classList.add('is-jomo-visible'); });
      return;
    }

    if (!cartRevealObserver) {
      cartRevealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-jomo-visible');
            cartRevealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
      );
    }

    elements.forEach(function (element, index) {
      if (element.hasAttribute('data-jomo-reveal')) return;
      element.setAttribute('data-jomo-reveal', '');
      element.style.setProperty('--jomo-reveal-delay', Math.min(index * 70, 210) + 'ms');
      cartRevealObserver.observe(element);
    });
  }

  function isMotionPage(pathname) {
    return pathname === '/' || pathname === '/cart' || pathname.indexOf('/products/') === 0;
  }

  function initPageTransitionFallback() {
    if (
      reducedMotion.matches ||
      typeof document.startViewTransition === 'function' ||
      !isMotionPage(window.location.pathname)
    ) {
      return;
    }

    document.documentElement.classList.add('jomo-page-fallback');

    document.addEventListener('click', function (event) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      var target = event.target;
      var link = target instanceof Element ? target.closest('a[href]') : null;
      if (!link || link.target || link.hasAttribute('download')) return;

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;

      var destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (
        destination.origin !== window.location.origin ||
        !isMotionPage(destination.pathname) ||
        destination.pathname === window.location.pathname
      ) {
        return;
      }

      event.preventDefault();
      if (document.documentElement.classList.contains('jomo-page-leaving')) return;

      document.documentElement.classList.add('jomo-page-leaving');
      window.setTimeout(function () {
        window.location.assign(destination.href);
      }, 170);
    });
  }

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(updateScrollMotion);
  }

  function init(root) {
    initLiquidHeader(root);
    initTilt(root);
    initHero(root);
    initScrollItems(root);
    initCartReveal(root);
    updateScrollMotion();
  }

  initPageTransitionFallback();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  window.addEventListener('pageshow', function () { updateScrollMotion(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();
